<!--
@name 硕士教育-国际商务管理硕士
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容 -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">专业介绍</div>
        <div class="selector-indent">
          国际商务管理专业是一门致力于培养具有国际视野、通晓商务基础与国际商务知识、拥有国际商务分析与决策能力，具有较高管理水平及较强的跨文化交流能力的敬业、精益、专注、创新的工匠型国际商务管理高端人才。我们的目标是为学生提供全面的商业知识和实践技能，为学生的职业发展和个人成长奠定坚实的基础，使他们能够在全球化的商业环境中取得成功。
        </div>
        <div class="selector-indent">
          学院的课程设置涵盖了国际商务管理的各个方面，注重理论与实践相结合，通过案例分析、团队项目和实习等方式，帮助学生将所学知识应用到实际商业场景中。
        </div>
      </div>
      <!--  专业介绍 -->
      <!--  项目优势 -->
      <div class="cont-item">
        <div class="title-image">项目优势</div>
        <div class="advantage">
          <p class="advantage-title">卓越资质</p>
          <p>AACSB认证的全球顶尖精英商校，中国教育部涉外信息监管网可查。</p>
          <p class="advantage-title">正规保障</p>
          <p>免考试，面试审核制入学，校本部直招，法国校本部学籍注册，中国国内在职研读。</p>
          <p>
            立足本土实用导向的课程设计，“课堂讲授+案例分析+共创工作坊+沉浸式研学”多种形式相结合，提升理论应用、分析和解决实际管理问题的能力。</p>
          <p class="advantage-title">中外联合</p>
          <p>国内一流大学师资及业内专家强强联合，法国高校教授鼎力加持。</p>
          <p class="advantage-title">资源对接</p>
          <p>庞大的校友网络、专家智库、政府与金融机构链接等，搭建高端商务交流、资源整合的优质平台。</p>
        </div>
      </div>
      <!-- 项目优势 -->
      <!-- 培养方式 -->
      <!--    <div class="cont-item">-->
      <!--      <div class="title-image">培养方式</div>-->
      <!--      <div class="selector-indent">-->
      <!--        法国布雷斯特高等商学院教育管理硕士专业采用线上教学加线下实践、自主学习和毕业论文相结合的方式进行为期18个月的学习，毕业季时组织学生集体去法国参加研修及毕业典礼。-->
      <!--      </div>-->
      <!--    </div>-->
      <!-- 培养方式 -->
      <!-- 课程简介 -->
      <div class="cont-item">
        <div class="title-image">课程设置</div>
        <p>
          国际商务管理硕士学制1.5年，共开设12门课程，其中9门必修课，2门选修课，1门语言课。采取线上和线下教学相结合的培养模式，修满60分则可进入论文撰写环节。</p>
        <img src="../assets/images/personRain/mibm-course.png" alt="" class="course-img"/>
      </div>
      <!-- 课程简介 -->
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">部分师资</div>
        <!--        <p>Abdelkader SBIHI：教授，巴黎索邦大学博士，塞尔吉·蓬图瓦兹大学塞纳河大学博士生导师。</p>-->
        <!--        <p>Camille Chédotal：副教授，巴黎多芬大学博士。</p>-->
        <!--        <p>Gaël TRIVIDIC：副教授，布列塔尼大学管理学博士。主攻咨询，消费品和文化领域。</p>-->
        <!--        <p>Gaëlle MOAL-ULVOAS：博士，BBS国际商务与市场学系国际关系副教授。</p>-->
        <!--        <p>Anne Hervéou：BBS研究生项目主管，管理学教授。</p>-->
        <p>Bertrand PAUGET：教授；管理学方向；现任教务长兼研究院院长。</p>
        <p>Dominique MAZÉ：副教授；国际战略与跨文化管理方向；EMBA项目主管。</p>
        <p>Houssem CHEMINGUI：副教授，信息系统与数据工程方向。</p>
        <p>Mériadec Le
          Mouillour：海事功勋骑士勋章获得者，前西布列塔尼工商会总经理，法国港口联盟副主席、高级海事委员会成员和欧洲海港组织执行委员会成员。</p>
        <p>张鹏：经济学博士，财政部政策实验室宏观经济首席专家，中国社科院宏观经济运行与财政政策研究组主要负责人。</p>
        <p>张智勇：北京大学心理学副教授，北京社会心理学会理事、副秘书长。</p>
        <p>冷柏军：对外经济贸易大学信息学院 一院长对外经济贸易大学国际商务研究中心一执行主任</p>
        <p>张勇：北京大学博士；南开大学国际法法学研究所所长；天津仲裁委员会涉外仲裁员；天津市人民政府法律顾问。</p>
        <p>
          尹文刚：中国科学院心理研究所教授、博导、研究员，中日友好医院神经心理研究与康复中心主任、加拿大阿尔伯特大学客座教授。</p>
        <p>
          王真：布雷斯特商学院特聘讲师列北京工商大学商学院讲师，MBA中心执行主任，于1998年获得国家科技部科技进步三等奖出版学术专著十二部，译著三部，发表学术论文四十余篇。</p>
        <p>熊伟：对外经贸大学国际商学院营销学系主任，全球研究中心副主任，管理学博士。</p>
      </div>
      <!-- 部分师资 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <div class="title-image">入学流程</div>
        <img src="../assets/images/personRain/mba-flow.png" alt="" class="flow-img"/>
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>本科或同等学历</p>
        <p>专科毕业，拥有3年及以上工作经验</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.中英文申请表</p>
          <p class="apply-text">2.中英文简历</p>
          <p class="apply-text">3.中英文动机信</p>
          <p class="apply-text">4.毕业证复印件及英文翻译件或学信网认证报告及翻译件</p>
          <p class="apply-text">5.身份证原件照片复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片电子版</p>
          <p class="apply-text">7.中文推荐信1封</p>
        </div>
        <!--申请材料-->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf">国际商务管理硕士</p>-->
      <!--      </div>-->
      <!--      <div style="clear: both" />-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容 -->
    <!-- 相关资料下载 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'EduDzsw',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3F/9E/wKgCEmfFyKyAXUEvAcImOiK1tXc570.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/eduDzsw.vue